import { useCompatMutation } from './useApolloCompat';
import { CHANGE_PASSWORD_MUTATION } from '../graphql/operations';

export function useChangePassword() {
  return useCompatMutation(CHANGE_PASSWORD_MUTATION);
}
